export type KeyValue = {
  Text: string
  Url: string | boolean | number | null | undefined
}

export interface LockMetadata {
  lockedBy?: string
  lastActivityAt?: string
  lockAcquisitionProbe?: boolean
  windowId?: string
  lockedByName?: string
  editingEnabled?: boolean
  lockByEmail?: string
}

export enum FlyoutOnboardingForm {
  SET_FLYOUT_ONBOARDING_FORM = 'SET_FLYOUT_ONBOARDING_FORM',
  UPDATE_FLYOUT_ONBOARDING_FORM = 'UPDATE_FLYOUT_ONBOARDING_FORM',
  UPDATE_FLYOUT_TEST_CONNECTION_STATUS = 'UPDATE_FLYOUT_TEST_CONNECTION_STATUS',
  UPDATE_FLYOUT_CAS_TEST_CONNECTION_STATUS = 'UPDATE_FLYOUT_CAS_TEST_CONNECTION_STATUS',
  UPDATE_MICROSOFT_ONBOARDING_FORM = 'UPDATE_MICROSOFT_ONBOARDING_FORM',
}
